export default "__VITE_ASSET__egxNYR71__"